import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { type SampleReceipt } from '../../../common/types';

interface IProps {
  item: SampleReceipt;
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  handleDeletingItem: (item: SampleReceipt) => any;
  handleSelectItem: (item: SampleReceipt) => any;
}

const ListSampleReceiptItem: React.FC<IProps> = ({
  item,
  toggleEditModal,
  toggleDeleteModal,
  handleDeletingItem,
  handleSelectItem
}) => {
  const deleteItemHandler = (): void => {
    toggleDeleteModal();
    handleDeletingItem(item);
  };

  const editItemHandler = (): void => {
    toggleEditModal();
    handleSelectItem(item);
  };

  return (
    <tr className="odd:bg-white even:bg-gray-50" key={item.id}>
      <td className="p-2 pl-8 text-sm text-gray-700">
        <div className="flex flex-col">
          <span>{item.title}</span>
        </div>
      </td>
      <td className="p-2 text-sm text-gray-700">{item.receipt.slice(0, 10) + '....'}</td>
      <td className="p-2 text-sm text-gray-700">{item.ownerEntityType}</td>
      <td className="p-2 text-sm text-gray-700">{item.ownerEntityId}</td>
      <td className="p-2 pr-8 text-sm text-left text-gray-700 ">
        <div className="flex flex-row justify-center items-center space-x-2">
          <span className="px-1 h-full" onClick={editItemHandler}>
            <AiOutlineEdit color="green" size={20} />
          </span>
          <>
            <span className="px-1 h-full" onClick={deleteItemHandler}>
              <AiOutlineDelete color="red" size={20} />
            </span>
          </>
        </div>
      </td>
    </tr>
  );
};

export default ListSampleReceiptItem;
